export enum PresenceAction {
    JOIN = 'join',
    LEAVE = 'leave',
    TIMEOUT = 'timeout',
    INTERVAL = 'interval',
    STATE_CHANGE = 'state-change',
};